import { GET_UPLOAD_TYPES, UPLOAD_BULK_FILE, RESET_UPLOAD_STATUS } from './actions';
import { REQUEST, SUCCESS, FAILURE } from '../../../utils/actionGenerator';

const defaultState = {
  uploadTypes: [],
  loadingTypes: false,
  uploading: false,
  uploadSuccess: false,
  uploadError: false,
  uploadMessage: '',
};

export default function (state = defaultState, action) {
  switch (action.type) {
    case GET_UPLOAD_TYPES[REQUEST]:
      return {
        ...state,
        loadingTypes: true,
      };
    case GET_UPLOAD_TYPES[SUCCESS]:
      return {
        ...state,
        loadingTypes: false,
        uploadTypes: action.response?.data || action.response || [],
      };
    case GET_UPLOAD_TYPES[FAILURE]:
      return {
        ...state,
        loadingTypes: false,
        uploadTypes: [],
      };
    case UPLOAD_BULK_FILE[REQUEST]:
      return {
        ...state,
        uploading: true,
        uploadSuccess: false,
        uploadError: false,
        uploadMessage: '',
      };
    case UPLOAD_BULK_FILE[SUCCESS]:
      return {
        ...state,
        uploading: false,
        uploadSuccess: true,
        uploadError: false,
        uploadMessage: action.response,
      };
    case UPLOAD_BULK_FILE[FAILURE]:
      return {
        ...state,
        uploading: false,
        uploadSuccess: false,
        uploadError: true,
        uploadMessage: action.response,
         };
      case RESET_UPLOAD_STATUS:
      return {
        ...state,
        uploadSuccess: false,
        uploadError: false,
        uploadMessage: '',
      };
    default:
      return state;
  }
}

export const getBulkUploadReducer = (state) => state.bulkUpload;

